import { render, staticRenderFns } from "./BannerTitle.vue?vue&type=template&id=19176a86&"
import script from "./BannerTitle.vue?vue&type=script&lang=ts&"
export * from "./BannerTitle.vue?vue&type=script&lang=ts&"
import style0 from "./BannerTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBanner,VBtn,VIcon})
